import { selector } from "recoil";
import { loginUserAtom } from "../atoms/loginUserAtoms";

export const loginUserSelector = selector({
  key: "loginUserSelector", // セレクターのユニークなキー
  get: ({ get }) => {
    const userAtom = get(loginUserAtom);
    return userAtom.user;
  },
});
